import '../css/main.css';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import SupervisorControlls from './user/supervisorControlls';
import MonitorWSService from '../services/monitorwsservice';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import SessionClosedNotification from './user/sessionClosedNotification';
import { setConnected, setConfig, setAlarms, setRecord } from '../redux/parametersSlice';
import useMonitorAPIService from '../services/monitorapiservice';
import BlockUi from 'react-block-ui';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import Toastr from "./utils/toastr.js"
import { setRTL } from '../redux/parametersSlice';
import AlarmsNotificator from './misc/alarmsNotificator';
import { updateLayout } from 'src/redux/supervisorSlice';

function Main(props) {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { getMonitorSettings, getUserParameters, checkIfRecordingIsAvailable } = useMonitorAPIService();
    const [showSessionClosedModal, setShowSessionClosedModal] = useState(false);
    const [wsUnautorized, setWsUnautorized] = useState(false);
    const [loading, setLoading] = useState(false);
    const toastrRef = useRef(null);

    const loadConfig = (token) => {

        setLoading(true);
        getMonitorSettings(token, (config) => {
            if (config.data) {
                let data = {
                    showDisconnectedAgents: config.data.showDisconnectedAgents,
                    hideMissedOnWelcome: config.data.hideMissedOnWelcome,
                    hideMissedOnQueue: config.data.hideMissedOnQueue,
                    onlyOpengroupCalls: config.data.onlyOpengroupCalls,
                    showOnly: config.data.monitor.showOnly,
                    refreshTime: config.data.monitor.refreshTime
                };
                props.setConfig(data);
            };

            getUserParameters(token, (alarms) => {
                if (alarms.data) {
                    let data = {
                        timeInQueue: alarms.data.timeInQueue,
                        maxConversation: alarms.data.maxConversation,
                        maxPauseTime: alarms.data.maxPauseTime,
                        maxDroppedCalls: alarms.data.maxDroppedCalls,
                        callDuration: alarms.data.callDuration,
                        callPeriod: alarms.data.callPeriod,
                        dialersActivity: alarms.data.dialersActivity,
                        formOpenWithoutActivity: alarms.data.formOpenWithoutActivity,
                        excludeAgents: alarms.data.excludeAgents,
                        notify: alarms.data.notify,
                        notifyAudio: alarms.data.notifyAudio
                    };

                    props.setAlarms(data);
                }
                checkIfRecordingIsAvailable(token, (resrec) => {
                    if (resrec.data)
                        props.setRecord(resrec.data.message === "TRUE");
                    setLoading(false);

                    let layoutStr = localStorage.getItem(`layout_user${localStorage.getItem("id")}`);
                    let layout = JSON.parse(layoutStr);
                    if (layout) {
                        props.updateLayout(layout);
                    }
                });
            })

        });
    }

    useEffect(() => {

        const handleConnectionLost = () => {
            toastrRef.current.setType("warning");
            toastrRef.current.setMessage(t("connectionlost"));
            toastrRef.current.show();
            props.setConnected(false);
            setTimeout(() => {
                MonitorWSService.connect(props.token, props.setConnected);
            }, 5000);

        };

        const handleForbiddenEvent = () => {
            setShowSessionClosedModal(true);
        };

        const handleWsUnautorized = () => {
            setShowSessionClosedModal(true);
            setWsUnautorized(true);
        };

        document.addEventListener('apiErrorForbidden', handleForbiddenEvent);
        document.addEventListener('wsConnectionLost', handleConnectionLost);
        document.addEventListener('wsConnectionUnauthorized', handleWsUnautorized);
        loadConfig(props.token);
        if (!props.connected)
            MonitorWSService.connect(props.token, props.setConnected);

        props.setRTL(document.dir === 'rtl');
        return () => {
            document.removeEventListener('apiErrorForbidden', handleForbiddenEvent);
            document.removeEventListener('wsConnectionLost', handleConnectionLost);
            document.removeEventListener('wsConnectionUnauthorized', handleWsUnautorized);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.connected) {
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/notify/`, function (notification) {
                var notify = notification.body;
                switch (notify) {
                    case "logout":
                        setShowSessionClosedModal(true);
                        break;
                    default: break;
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const updateView = useCallback((view) => {
        navigate(view);
    }, [navigate]);

    return (<>
        <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
            <div className="d-flex flex-column flex-root">
                <div className="page d-flex flex-row flex-column-fluid">
                    <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                        <div className="header">
                            <div className="header-top d-flex align-items-stretch flex-grow-1">
                                <div className="d-flex align-items-stretch">
                                    <div className="d-flex align-items-center align-items-lg-stretch me-5 flex-row-fluid">
                                        <button className="d-lg-none btn btn-icon btn-color-white bg-hover-white bg-hover-opacity-10 w-35px h-35px h-md-40px w-md-40px ms-n2 me-2" id="kt_header_navs_toggle">
                                            <FontAwesomeIcon size='2x' icon={duotone("bars")} />
                                        </button>
                                        <a href="/fidelitymonitor/" onClick={e => e.preventDefault()} className="d-flex align-items-center" >
                                            <img alt="Logo" src="img/loginlogo.png" className="h-50px" />
                                        </a>
                                        <div className="align-self-end overflow-auto" id="kt_brand_tabs">
                                            <div className="header-tabs overflow-auto mx-4 ms-lg-10 mb-5 mb-lg-0" id="kt_header_tabs" >
                                                <ul className="nav flex-nowrap text-nowrap">
                                                    <li className="nav-item" >
                                                        <a className={"nav-link " + (window.location.hash.indexOf("dashboard") > -1 ? "active" : "")} data-bs-toggle="tab" href="dashboard" onClick={e => { e.preventDefault(); updateView("dashboard") }}>{t("dashboard")}</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={"nav-link " + (window.location.hash.indexOf("agents") > -1 ? "active" : "")} data-bs-toggle="tab" href="agents" onClick={e => { e.preventDefault(); updateView("agents") }}>{t("agents")}</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={"nav-link " + (window.location.hash.indexOf("groups") > -1 ? "active" : "")} data-bs-toggle="tab" href="groups" onClick={e => { e.preventDefault(); updateView("groups") }}>{t("groups")}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <SupervisorControlls updateView={updateView}></SupervisorControlls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Row>
                <Col>
                    <Outlet />
                </Col>
            </Row>

            <SessionClosedNotification wsUnautorized={wsUnautorized} show={showSessionClosedModal} hideModal={setShowSessionClosedModal}></SessionClosedNotification>
            <AlarmsNotificator></AlarmsNotificator>
            <Toastr ref={toastrRef} />
        </BlockUi>

    </>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { setConnected, setConfig, setAlarms, setRecord, setRTL, updateLayout })(Main);
